import React, { Component } from 'react';
import jQuery from 'jquery';

import Core from './../../../Core/Core'
import ErrorManager from '../../../Core/ErrorManager';

import Header from './../../Header';
import Users from './../../User/Users';
import UserForm from './../../User/UserForm';
import ExportStatsModal from './../../User/ExportStatsModal';
import ErrorBoundary from '../ErrorBoundary';

class UsersEdit extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "users" : [], 
            "user" : {},
        };

        this.load = this.load.bind(this);
        this.submit = this.submit.bind(this);
        this.handleRedux = this.handleRedux.bind(this);
        this.loadUser = this.loadUser.bind(this);

        this.load();
    }

    componentDidMount()
    {
        document.title = "W-F: Utilisateurs";
    }

    load()
    {
        Core.Instance.Request(Core.Address+"User", null, "GET")
        .then((data) => {
            this.setState({
                "users" : data ? data : []
            });
        });
    }

    loadUser(id)
    {
        Core.Instance.Request(Core.Address+"User/"+id, null, "GET")
        .then((data) => {
            if(data == null)
            {
                ErrorManager.Instance.Handle("Aucun avis ne possède cet identifiant.");
                return;
            }

            jQuery('#addUserModal').modal('show');
            this.setState({
                "user" : data 
            });
        });
    }

    handleRedux(event)
    {
        let user = this.state.user;
        user[event.target.name] = event.target.value;
        this.setState({
            "user" : user
        });
    }

    submit()
    {
        if(Object.getOwnPropertyNames(this.state.user).length <= 0)
        {
            ErrorManager.Instance.Handle("Vous devez remplir le formulaire avant de pouvoir enregistrer.");
            return;
        }

        if(!Core.Instance.CheckForm(this))
            return;
        let user = this.state.user;
        //user.date = user.date != null ? user.date/1000 : null;
        let request = null;
        if(user.id){
            request = Core.Instance.Request(Core.Address+"User/"+user.id, user, "PUT");
        }else{
            request = Core.Instance.Request(Core.Address+"User", user, "POST");
        }
        request.then((json) => {
            // ErrorManager.Instance.Info("Les modifications ont bien été enregistrées.");
            window.location.reload();
        });      
    }

    render()
    {
        return (
            <ErrorBoundary>
                <Header buttons={ [
                    <div className="dropdown btn-group" key="exportDDL">
                        <button className="btn btn-primary" type="button" data-toggle="modal" data-target="#user-stats">
                        <li className="fas fa-file-export"></li> Exporter
                        </button>
                    </div>
                ] } />
                <ExportStatsModal />
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="card m-3 p-3">
                                <div className="card-body">
                                    <div className="card-title">
                                        <span className="h4 align-middle">Utilisateurs</span>
                                        <span className="float-right" data-toggle="modal" data-target="#addUserModal">
                                            <a href="#"><li className='fas fa-plus'></li> <u>Ajouter un utilisateur</u></a>    
                                        </span>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <Users users={ this.state.users } editing={ true } loadUser={ this.loadUser }/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <UserForm user={ this.state.user } onChange={ this.handleRedux } onSubmit={ this.submit } />
                </div>
            </ErrorBoundary>
        );
    }
}
export default UsersEdit;



// WEBPACK FOOTER //
// ./src/Components/Views/User/UsersEdit.js